/* eslint-disable */
import { useContext, useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { AppContext, MainContext } from '../context/ApiContext';
import Profile from '../pages/Profile';
import Dashboard from '../pages/Dashboard';
import Channels from '../pages/Channels';
import Insurances from '../pages/Insurances';
import Partners from '../pages/Partners';
import Users from '../pages/Users';
import Clients from '../pages/Clients';
import LeadsVerification from '../pages/LeadsVerification';
import UserIndication from '../pages/UserIndication';
import SelfIndication from '../pages/SelfIndication';
import InidicationReport from '../pages/InidicationReport';
import ExternalIndication from '../pages/ExternalIndication';
import InidicationManagerReport from '../pages/InidicationManagerReport';
import SalesReport from '../pages/SalesReport';
import InidicationReportGerVeic from '../pages/InidicationReportGerVeic';
import LostSaleReport from '../pages/LostSaleReport';
import Lead from '../pages/Lead';
import TechnicalTeam from '../pages/TechnicalTeam';
import LoadingPage from '../pages/LoadingPage';
import CallsReport from '../pages/CallsReport';
import AttendanceReport from '../pages/AttendanceReport';
import FunnelChart from '../pages/FunnelChart';
import { useAuth } from '../hooks/useAuth';
import ProcessesReport from '../pages/ProcessesReport/index';
import RenovationReport from '../pages/RenovationReport';
import DiagnosisReport from '../pages/DiagnosisReport';
import NewInsurancesReport from '../pages/NewInsurancesReport';
import LeadBrokerConfig from '../pages/LeadBrokerConfig';
import CustomerMat from '../pages/CustomerMat';
import AttendancePresencialReport from '../pages/AttendancePresencialReport';
import DuplicadeLeadsReport from '../pages/DuplicadeLeadsReport';
import ChatBot from '../pages/ChatBot';
import OriginLeadsReport from '../pages/OriginLeadsReport';
import FiIndicationReport from '../pages/FiIndicationReport';

export default function MainRoutes() {
  const { user } = useAuth();
  const [role, setRole] = useState(null);

  useEffect(() => {
    setRole(user.role);
  }, [user]);

  return (
    // <AppContext>
    <AnimatePresence>
      <Switch>
        {!role && <LoadingPage />}
        <Route exact path="/funnel-charts" component={FunnelChart} />
        {role >= 4 && (
          <>
            <Route exact path="/" component={role == 5 ? InidicationReport : UserIndication} />
            <Route exact path="/profile" component={Profile} />
            {(role == 5 || role == 7) && (
              <>
                <Route exact path="/relatorio-indicador" component={InidicationReport} />
                <Route exact path="/indicacao-externa" component={ExternalIndication} />
              </>
            )}
            {role == 4 && (
              <Route exact path="/relatorio-indicacoes-concessionaria" component={InidicationReportGerVeic} />
            )}
          </>
        )}
        {role < 4 && ( // Admin - Gerente corretora - corretor
          <>
            <Route exact path="/" component={Dashboard} />
            <Route exact path="/users" component={Users} />
            <Route exact path="/clients" component={Clients} />
            {/* <Route exact path="/relatorio-indicador" component={InidicationReport} /> */}
            <Route exact path="/profile" component={Profile} />
            <Route exact path="/conferencia-informacoes-lead" component={LeadsVerification} />
            {role == 3 && (
              <>
                <Route exact path="/lead" component={UserIndication} />
                <Route exact path="/seguros" component={Insurances} />
                <Route exact path="/parceiros" component={Partners} />
                <Route exact path="/technical-team" component={TechnicalTeam} />
                <Route exact path="/relatorio-indicacoes-corretora" component={InidicationManagerReport} />
                <Route exact path="/relatorio-ligacoes" component={CallsReport} />
                <Route exact path="/relatorio-perdas" component={LostSaleReport} />
              </>
            )}
            {(role == 1 || role == 2) && ( //Admin + gerente corretora
              <>
                {/* <Route exact path="/canais" component={Channels} />*/}
                <Route exact path="/lead" component={Lead} />
                <Route exact path="/seguros" component={Insurances} />
                <Route exact path="/parceiros" component={Partners} />
                <Route exact path="/technical-team" component={TechnicalTeam} />
                <Route exact path="/relatorio-indicacoes-corretora" component={InidicationManagerReport} />
                <Route exact path="/relatorio-indicacoes-concessionaria" component={InidicationReportGerVeic} />
                <Route exact path="/relatorio-ligacoes" component={CallsReport} />
                <Route exact path="/relatorio-perdas" component={LostSaleReport} />
                <Route exact path="/relatorio-indicacao-fi" component={FiIndicationReport} />
              </>
            )}
            {role == 1 && (
              <>
                <Route exact path="/indicacao-externa" component={ExternalIndication} />
                <Route exact path="/relatorio-processamentos" component={ProcessesReport} />
                <Route exact path="/chat-bot" component={ChatBot} />
                {/* suspended */}
                {/* <Route exact path="/esteira-cliente" component={CustomerMat} /> */}

                {/* <Route exact path="/indicacao-externa" component={ExternalIndication} /> */}
                <Route exact path="/relatorio-vendas-quiver" component={SalesReport} />
                <Route exact path="/relatorio-diagnostico-presencial" component={AttendancePresencialReport} />
              </>
            )}
            {(role == 1 || role == 3) && (
              <>
                <Route exact path="/relatorio-renovacoes" component={RenovationReport} />
                <Route exact path="/relatorio-atendimento" component={AttendanceReport} />
                {/* <Route exact path="/relatorio-processamentos" component={ProcessesReport} /> */}
                {/* suspended */}
                {/* <Route exact path="/relatorio-novos-seguros" component={NewInsurancesReport} /> */}
                {/* suspended */}
                <Route exact path="/relatorio-diagnostico" component={DiagnosisReport} />

                <Route exact path="/lead-broker-config" component={LeadBrokerConfig} />
                <Route exact path="/auto-indicação" component={SelfIndication} />
                <Route exact path="/relatorio-leads-duplicados" component={DuplicadeLeadsReport} />
                <Route exact path="/relatorio-leads-origem" component={OriginLeadsReport} />
              </>
            )}
          </>
        )}
        {/* {(role == 1 || role == 4) && ( //Admin + gerente concessionária
            <Route exact path="/relatorio-indicacoes-concessionaria" component={InidicationReportGerVeic} />
          )} */}
        {/* {(role == 5 || role == 4) && ( // inidcador ou gerente concessionária
            <>
              <Route exact path="/" component={UserIndication} />
              <Route exact path="/relatorio-indicador" component={InidicationReport} />
            </>
          )} */}
      </Switch>
    </AnimatePresence>
    // </AppContext>
  );
}
